import axios from '@axios'

export default {
  createContract(params) {
    return axios.post('/api/v-contract/contracts', params)
  },
  getProvinces() {
    return axios.get('/api/v-contract/administrative-units/provinces', { params: { isNew: true } })
  },
  getWards(provinceCode) {
    return axios.get('/api/v-contract/administrative-units/wards', { params: { provinceCode } })
  },
  getContract() {
    return axios.get('/api/v-contract/contracts')
  },
  updateContract(params) {
    return axios.put('/api/v-contract/contracts', params)
  },
}
